import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const DataMining = ({ branch = "AIDS", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Data Mining Basics: What is Data Mining, Kinds of Patterns to be Mined, Tasks of Data Mining, Data Mining Applications: The Business Context of Data Mining, Data Mining as a Research Tool, Data Mining for Marketing, Benefits of Data Mining, Data Warehousing vs Data Mining.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Data Pre-processing: Review of Data Pre-processing: Types of Data, Data Quality, Measurement and Data Collection Issues, Feature Subset Selection, Feature Creation, Data Discretization and Binning, Knowledge Discovery in Databases.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Machine Learning in Data Mining: Types of classifiers, Rule based classifiers, Model Selection, Model Evaluation, Ensemble Methods, Bias-Variance trade-off, Handling Class Imbalance Problem, Association Rule Mining: Mining Frequent Patterns, Market Basket Analysis, Apriori algorithm, Data Mining using decision trees and KNN algorithm.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Cluster Analysis: Different Types of Clusters, Hierarchical Methods of Clustering, Density based Clustering: DBSCAN algorithm, Cluster Evaluation. Outlier Analysis, Outlier Detection Methods, Mining Complex Data Types, avoiding False Discoveries.</p>
    </div>
  ];

  const tabData = [
    { id: 'syllabus', label: 'Syllabus', content: null },
    { id: 'notes', label: 'Notes', content: null },
    { id: 'important', label: 'Important Questions', content: null },
    { id: 'books', label: 'Books', content: null },
    { id: 'PYQ', label: 'PYQ', content: null },
    { id: 'youtube_playlist', label: 'Video Lectures', content: null },
  ];

  return (
    <SubjectPage
      subjectName="Data Mining"
      subjectKey="datamining"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'DataMiningNotes',
        videos: 'DataMiningVideos'
      }}
    />
  );
};

export default DataMining;